export enum ReportFileType {
  CSV = 'csv',
  EXCEL = 'xlsx',
  PDF = 'pdf',
}

export enum GenerateReport {
  SALES_REPORT = 'salesReport',
  TIME_CARD_REPORT = 'timeCardReport',
  PAYROLL_REPORT = 'payrollReport',
  MERCHANT_REPORT = 'merchantReport',
}

// Report Enums
export enum ReportsGroupBy {
  TIME = 'time',
  ROLE = 'role',
}

export enum ReportsTimeUnit {
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
}

export enum RestaurantType {
  TSR = 'TSR',
  QSR = 'QSR',
}

export interface BreaksReportResponse {
  data: {
    compliancePercentage: number;
    breaksTaken: number;
    missedBreaks: number;
    waivedBreaks: number;
    costOfMissedBreaks: number;
    startDate: string;
    endDate: string;
    period: string;
  };
}

export type DateRangeString = {
  startDate: string;
  endDate: string;
};
